<div class="tml-tpl-input tam-contact-control">
    <kendo-dropdownlist [style.width.px]="childConfig.css.width" [disabled]="true">
        <ng-template kendoMultiSelectHeaderTemplate>
            <div class="popup-template-clear-header">
                <span class="multiselect-Clear" (click)="clearValue()">Clear</span>
            </div>
        </ng-template>
    </kendo-dropdownlist>
</div>